import { DataTable, DataTableEmptyRow } from '../../components/ui'
import type { FlowWireRow } from '../../api/dedicatedReports'
import { eur, pct } from './DedicatedReportShell'

/** Tabella di flusso comune a qualità, settori e classifica: gli importi compaiono solo se il server li manda. */
export function FlowTable({ rows, first, ranked = false }: { rows: FlowWireRow[]; first: string; ranked?: boolean }) {
  const money = rows.some(r => r.accrued !== undefined)
  const cols = 8 + (ranked ? 1 : 0) + (money ? 3 : 0)
  return (
    <DataTable>
      <thead>
        <tr>
          {ranked && <th className="text-end md-num">#</th>}
          <th>{first}</th>
          <th className="text-end md-num">Inserite</th>
          <th className="text-end md-num">Attivate</th>
          <th className="text-end md-num">Tasso attivazione</th>
          <th className="text-end md-num">Scartate</th>
          <th className="text-end md-num">Tasso scarti</th>
          <th className="text-end md-num">Stornate</th>
          <th className="text-end md-num">Tasso storni</th>
          {money && <><th className="text-end md-num">Presunto</th><th className="text-end md-num">Maturato</th><th className="text-end md-num">Incassato</th></>}
        </tr>
      </thead>
      <tbody>
        {rows.map(r => (
          <tr key={r.key}>
            {ranked && <td className="text-end md-num">{r.rank}</td>}
            <td>{r.label}</td>
            <td className="text-end md-num">{r.inserted}</td>
            <td className="text-end md-num">{r.activated}</td>
            <td className="text-end md-num">{pct(r.activationRate)}</td>
            <td className="text-end md-num">{r.rejected + r.cancelled}</td>
            <td className="text-end md-num">{pct(r.rejectionRate)}</td>
            <td className="text-end md-num">{r.reversed}</td>
            <td className="text-end md-num">{pct(r.reversalRate)}</td>
            {money && <><td className="text-end md-num">{eur(r.presumed)}</td><td className="text-end md-num">{eur(r.accrued)}</td><td className="text-end md-num">{eur(r.collected)}</td></>}
          </tr>
        ))}
        {rows.length === 0 && <DataTableEmptyRow colSpan={cols} title="Nessun dato nel periodo." />}
      </tbody>
    </DataTable>
  )
}
